import React, { useState, useEffect } from 'react';
import BackupService from '../../services/BackupService'; // Use the BackupService for fetching backups
import Spinner from '../../components/Spinner'; // Optional: Add a loading spinner component

const BackupList = () => {
    const [backups, setBackups] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [backupsPerPage] = useState(5);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchBackups();
    }, []);

    const fetchBackups = async () => {
        setLoading(true);
        setError(null); // Reset any previous errors
        try {
            const data = await BackupService.getAll();
            setBackups(data);
        } catch (err) {
            console.error('Error fetching backups:', err);
            setError('Failed to fetch backups. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    const filteredBackups = backups.filter((backup) =>
        backup.system_name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const indexOfLastBackup = currentPage * backupsPerPage;
    const indexOfFirstBackup = indexOfLastBackup - backupsPerPage;
    const currentBackups = filteredBackups.slice(indexOfFirstBackup, indexOfLastBackup);

    const totalPages = Math.ceil(filteredBackups.length / backupsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    if (loading) {
        return <Spinner />; // Optional: Display a spinner while loading
    }

    if (error) {
        return (
            <div className="alert alert-danger text-center" role="alert">
                {error}
            </div>
        );
    }

    const formatBytes = (bytes) => {
        if (bytes === 0 || bytes === null) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        const converted = parseFloat((bytes / Math.pow(k, i)).toFixed(2));
        return `${converted} ${sizes[i]}`;
    };
    

    return (
        <div className="content-wrapper">
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">
                                <i className="ti-harddrives menu-icon text-primary mr-2"></i>
                                Backup Records
                            </h4>
                            <p className="card-description">View and manage all backups</p>

                            {/* Search Bar */}
                            <div className="d-flex justify-content-end align-items-center mb-3">
                                <input
                                    type="text"
                                    className="form-control form-control-sm w-50"
                                    placeholder="Search backups..."
                                    value={searchQuery}
                                    onChange={handleSearch}
                                />
                            </div>

                            {/* Backups Table */}
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th><i className="ti-server menu-icon"></i> System Name</th>
                                        <th><i className="ti-calendar menu-icon"></i> Backup Time</th>
                                        <th><i className="ti-bar-chart menu-icon"></i> Backup Size</th>
                                        <th><i className="ti-database menu-icon"></i> Database Name</th>
                                        <th><i className="ti-check-box menu-icon"></i> Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentBackups.length > 0 ? (
                                        currentBackups.map((backup) => (
                                            <tr key={backup.id}>
                                                <td>{backup.system_name}</td>
                                                <td>{new Date(backup.backup_date_time).toLocaleString()}</td>
                                                <td>{formatBytes(backup.backup_size)}</td>

                                                <td>{backup.database_name}</td>
                                                <td>
                                                    {backup.status === 'succeeded' ? (
                                                        <span className="badge badge-success">
                                                            <i className="ti-check menu-icon"></i> Succeeded
                                                        </span>
                                                    ) : (
                                                        <span className="badge badge-danger">
                                                            <i className="ti-close menu-icon"></i> Failed
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center">
                                                <i className="ti-alert menu-icon"></i> No backups found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            {/* Pagination Controls */}
                            {totalPages > 1 && (
                                <nav>
                                    <ul className="pagination justify-content-center mt-3">
                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                            <li
                                                key={page}
                                                className={`page-item ${page === currentPage ? 'active' : ''}`}
                                            >
                                                <button onClick={() => paginate(page)} className="page-link">
                                                    {page}
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </nav>
                            )}
                        </div>

                        <div className="card-footer text-muted">
                            <i className="ti-info menu-icon"></i> Showing {currentBackups.length} of {filteredBackups.length} backups
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default BackupList;
